export class TaskUnit {
    public Id: string;
    public UnitListId: string;
    public Identifier: string;
    public Name: string;
    public TaskId: string;
    public UnitPrice: number;
    public UnitOfMeasurement: string;
    public BudgetedAmount: number;
    public PlannedAmount: number;
    public OrderedAmount: number;
    public SuppliedAmount: number;
    public InvoicedAmount: number;
    public InvoicedTotalValue: number;
    public PlannedTotalValue: number;
    public OrderedTotalValue: number;
    public BudgetedTotalValue: number;
    public SuppliedTotalValue: number;
    public SourceUnitId: string;
    public GroupIdentifier: string;
    public GroupName: string;
    public VersionName: string;
    public IsInvoiced: boolean;
    public IsPriceListPrice: boolean;
    public UserGivenPrice: boolean;
    public WorkTimeInMinutes: number;
    public UserGivenWorktime: boolean;
    public IsPriceListWorktime: boolean;
    public SuppliedAmountEntries: TaskUnitSuppliedEntry[];
    public CostAccountings: TaskUnitCostAccounting[];
    public OwnerCompanyId: string;
    public Created: string;

    /* Following properties do not exists in backend entity */
    public IsListUnit: boolean;
    public NewSuppliedEntryAmount: number
    public NewSuppliedEntrySuppliedDate: Date;
    public NewSuppliedEntryDescription: string;
    public IsNew: boolean;


    /* Following might get removed */
    public _originalValues: TaskUnit;

    /*
    * Checks if is dirty by comparing to values of a shallow clone of
    * the TaskUnit given in constructor.
    */
    get IsDirty(): boolean {

        return !
            (this._originalValues.OrderedAmount === this.OrderedAmount
                && this._originalValues.Name === this.Name
                && this._originalValues.BudgetedAmount === this.BudgetedAmount
                && this._originalValues.PlannedAmount === this.PlannedAmount
                && this._originalValues.SuppliedAmount === this.SuppliedAmount
                && this._originalValues.UnitListId === this.UnitListId
                && this._originalValues.UnitOfMeasurement === this.UnitOfMeasurement
                && this._originalValues.UnitPrice === this.UnitPrice
                && this._originalValues.WorkTimeInMinutes === this.WorkTimeInMinutes);
    }

    public clearIsDirty(): void {
        this._originalValues = Object.assign({}, this);
    }

    public toBackendEntity(): TaskUnit {
        const entity = Object.assign({}, this);

        delete entity.IsListUnit;
        delete entity.SuppliedAmountEntries;
        delete entity.CostAccountings;
        delete entity.NewSuppliedEntryAmount;
        delete entity.NewSuppliedEntrySuppliedDate;
        delete entity.NewSuppliedEntryDescription;
        delete entity._originalValues;
        delete entity.OwnerCompanyId;
        delete entity.IsNew;

        return entity;
    }

    fillFromJson(unit: any) {
        if (unit['Id']) { this.Id = unit['Id'] }
        if (unit['UnitListId']) { this.UnitListId = unit['UnitListId'] }
        if (unit['TaskId']) { this.TaskId = unit['TaskId'] }

        if (unit['SourceUnitId']) { this.SourceUnitId = unit['SourceUnitId'] }
        if (unit['IsListUnit']) { this.IsListUnit = unit['IsListUnit'] }
        if (unit['VersionName']) { this.VersionName = unit['VersionName'] }
        if (unit['GroupIdentifier']) { this.GroupIdentifier = unit['GroupIdentifier'] }
        if (unit['GroupName']) { this.GroupName = unit['GroupName'] }

        if (unit['Identifier']) { this.Identifier = unit['Identifier'] }
        if (unit['Name']) { this.Name = unit['Name'] }
        if (unit['UnitOfMeasurement']) { this.UnitOfMeasurement = unit['UnitOfMeasurement'] }

        if (unit['UnitPrice'] !== undefined) { this.UnitPrice = unit['UnitPrice'] }
        if (unit['IsInvoiced']) { this.IsInvoiced = unit['IsInvoiced'] }
        if (unit['IsPriceListPrice']) { this.IsPriceListPrice = unit['IsPriceListPrice'] }
        if (unit['UserGivenPrice']) { this.UserGivenPrice = unit['UserGivenPrice'] }

        if (unit['BudgetedAmount'] !== undefined) { this.BudgetedAmount = unit['BudgetedAmount'] }
        if (unit['PlannedAmount'] !== undefined) { this.PlannedAmount = unit['PlannedAmount'] }
        if (unit['OrderedAmount'] !== undefined) { this.OrderedAmount = unit['OrderedAmount'] }
        if (unit['SuppliedAmount'] !== undefined) { this.SuppliedAmount = unit['SuppliedAmount'] }

        if (unit['WorkTimeInMinutes'] !== undefined) { this.WorkTimeInMinutes = unit['WorkTimeInMinutes'] }
        if (unit['UserGivenWorktime']) { this.UserGivenWorktime = unit['UserGivenWorktime'] }
        if (unit['IsPriceListWorktime']) { this.IsPriceListWorktime = unit['IsPriceListWorktime'] }

        if (unit['SuppliedAmountEntries']) { this.SuppliedAmountEntries = unit['SuppliedAmountEntries'] }
        if (unit['CostAccountings']) { this.CostAccountings = unit['CostAccountings'] }
        if (unit['OrderedTotalValue']) { this.OrderedTotalValue = unit['OrderedTotalValue'] }
        if (unit['SuppliedTotalValue']) { this.SuppliedTotalValue = unit['SuppliedTotalValue'] }
        if (unit['PlannedTotalValue']) { this.PlannedTotalValue = unit['PlannedTotalValue'] }
        if (unit['BudgetedTotalValue']) { this.BudgetedTotalValue = unit['BudgetedTotalValue'] }
        if (unit['OwnerCompanyId']) { this.OwnerCompanyId = unit['OwnerCompanyId'] }

        if (unit['Created'] !== undefined) { this.Created = unit['Created'] }

        this.NewSuppliedEntryDescription = ''; //  for not to show 'undefined' in text input field

        this.clearIsDirty();

        return this;
    }


}

export class TaskUnitSuppliedEntry {
    public Id: string;
    public TaskId: string;
    public UnitId: string;
    public Modified: Date;
    public Modifier: string;
    public Amount: number;
    public Description: string = ''; // for not to show 'undefined' in text input field

    public IsDirty: boolean;
}


export class TaskUnitCostAccounting {
    public Id: string;
    public TaskUnitId: string;
    public TaskId: string;
    public CompanyId: string;
    public Type: string;
    public Value: string;
    public IsValid: boolean;
    public IsValidOn: {
        TaskSend: boolean;
        InvoicingProposalSend: boolean;
        InvoicingProposalAccept: boolean;
    }
}

// Helper enum for sorting task unit cost accountings according to their type.
export enum TucaTypeOrderComparer {
    MainTaskUnitCostAccounting,             // 2-tasoinen kustannuskohdistus
    SubTaskUnitCostAccounting,              // 2-tasoinen kustannuskohdistus
    TwoLevelProjectTaskUnitCostAccounting,  // Projekti 2-tasoinen valintalista
    SubProjectTaskUnitCostAccounting,       // Alaprojekti
    LitteraTaskUnitCostAccounting,          // Littera
    DeliveryDateCostAccounting,             // Toimituspäivämäärä
    DestinationTaskUnitCostAccounting,      // Kohde
    AccountTaskUnitCostAccounting,          // Tili
    BusinessAreaCostAccounting,             // Liiketoimintoalue
    FunctionTaskUnitCostAccounting,         // Toiminto
    ProjectTaskUnitCostAccounting,          // Projekti
    DescriptionTaskUnitCostAccounting,      // Selite
    OperatingLocationTaskUnitCostAccounting,// Käyttöpaikka
    ExpenseTypeTaskUnitCostAccounting,      // Kustannuslaji
}

export class ComplexTuca {
    static NameIdentifierMapper: Array<{ Name: string, Values: Array<{ TooltipTitle: string, Identifier: string, Name: string }> }> =
        [{
            Name: 'TwoLevelProjectTaskUnitCostAccounting',
            Values: [
                {
                    TooltipTitle: 'MainProject',
                    Identifier: 'MainProjectIdentifierTaskUnitCostAccounting',
                    Name: 'MainProjectNameTaskUnitCostAccounting'
                },
                {
                    TooltipTitle: 'Project',
                    Identifier: 'ProjectIdentifierTaskUnitCostAccounting',
                    Name: 'ProjectNameTaskUnitCostAccounting'
                }
            ]
        }]
}
